'use strict';

const { getDependencyClass } = require('../../../lib/dependencies.js');

module.exports = getDependencyClass('phoenix-page').then((pageClass) => {
    class PhoenixAccordionPanel extends pageClass.PhoenixElement {
        get observedBroadcastedEvents() {
            return ['phoenix:accordion:active'];
        }

        connectedCallback() {
            super.connectedCallback();
            this.accordionId = this.getAttr('accordion-id', { required: true });
        }

        broadcastedEventCallback(name, args = {}) {
            const itemId = args.detail && args.detail.itemId;
            const accordionId = args.detail && args.detail.accordionId;

            if (accordionId !== this.accordionId) {
                return;
            }

            switch (name) {
                case 'phoenix:accordion:active':
                    this.hidden = this.id !== 'panel-' + itemId;
                    break;
            }
        }
    }
    window.customElements.define('phoenix-accordion-panel', PhoenixAccordionPanel);
});
